import {
  Box,
  colors,
  Typography,
  ButtonGroup,
  Button,
  Divider,
} from "@mui/material";
import { Draggable } from "react-beautiful-dnd";

import { FormValuesType } from "pages";
import { SectionItemList } from "./SectionItemList";

import { theme } from "constants/theme";

export const SectionItem: React.FC<{
  sectionName: string;
  uniqueName: string;
  index: number;
  fieldsList: FormValuesType[];
  sectionId: string;
  isEditing: boolean;
  repeat: boolean;
  fieldRef: string;
  required: boolean;
  editSection: (data: {
    type: "edit" | "delete";
    sectionId: string;
    fieldId?: string;
    fieldIndex?: number;
  }) => void;
  resetFormWithValues: (item: FormValuesType) => void;
}> = ({
  sectionName,
  uniqueName,
  index,
  fieldsList,
  sectionId,
  editSection,
  isEditing,
  resetFormWithValues,
  repeat,
  fieldRef,
  required,
}) => {
  return (
    <Draggable draggableId={sectionId} index={index}>
      {(provided, snapshot) => (
        <Box
          sx={{
            border: theme.borderPrimary,
            p: 2,
            mt: 2,
            ":hover": {
              cursor: "move",
            },
            borderRadius: 1,
            backgroundColor:
              snapshot.isDragging || isEditing
                ? colors.blueGrey["300"]
                : "white",
          }}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
        >
          <Box
            display={"flex"}
            sx={{
              alignItems: "flex-start",
              mb: 2,
            }}
          >
            <Box
              sx={{ maxWidth: "50%" }}
              display={"flex"}
              flexDirection={"column"}
            >
              <Typography>{"Section label: " + sectionName}</Typography>
              <Typography>{"Unique name: " + uniqueName}</Typography>
              <Typography>{"Repeat: " + repeat}</Typography>
              {fieldRef ? (
                <Typography>{"Field reference: " + fieldRef}</Typography>
              ) : null}
              <Typography>{"Required: " + required}</Typography>
            </Box>

            <ButtonGroup
              variant="contained"
              aria-label="Section modify button group"
              style={{
                marginLeft: "auto",
                maxWidth: "50%",
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={() => {
                  editSection({ type: "edit", sectionId });
                }}
              >
                Edit
              </Button>
              <Button
                onClick={() => {
                  editSection({
                    type: "delete",
                    sectionId,
                  });
                }}
              >
                Delete
              </Button>
            </ButtonGroup>
          </Box>
          <Divider />

          <SectionItemList
            sectionId={sectionId}
            fieldsList={fieldsList}
            resetFormWithValues={resetFormWithValues}
            removeField={(fieldId: string, fieldIndex: number) => {
              editSection({
                type: "delete",
                sectionId,
                fieldId,
                fieldIndex,
              });
            }}
          />
        </Box>
      )}
    </Draggable>
  );
};
